module.exports = __webpack_public_path__ + "static/media/smartContract.d38a8276.avif";